module.exports = "/_next/static/images/27b3a9f83942321779588ad44d977fcf-savings-hero-lg.jpg";